var exports = {
  "iE": "ScrollFillerSkeleton.module__wrapper___NmluSn",
  "hw": "ScrollFillerSkeleton.module__wrapperCompact___NmluSn",
  "vy": "ScrollFillerSkeleton.module__messageGroup___NmluSn",
  "Os": "ScrollFillerSkeleton.module__group___NmluSn",
  "my": "ScrollFillerSkeleton.module__avatar___NmluSn",
  "rf": "ScrollFillerSkeleton.module__body___NmluSn",
  "wx": "ScrollFillerSkeleton.module__header___NmluSn",
  "el": "ScrollFillerSkeleton.module__cozyLeadLine___NmluSn",
  "B8": "ScrollFillerSkeleton.module__cozyContinuation___NmluSn",
  "Tw": "ScrollFillerSkeleton.module__cozyContinuationLine___NmluSn",
  "Xw": "ScrollFillerSkeleton.module__cozyAttachment___NmluSn",
  "Ov": "ScrollFillerSkeleton.module__compactMessages___NmluSn",
  "ir": "ScrollFillerSkeleton.module__compactRow___NmluSn",
  "ce": "ScrollFillerSkeleton.module__compactTimestamp___NmluSn",
  "Ys": "ScrollFillerSkeleton.module__compactBody___NmluSn",
  "tQ": "ScrollFillerSkeleton.module__compactAuthorPrefix___NmluSn",
  "hn": "ScrollFillerSkeleton.module__compactAvatar___NmluSn",
  "_l": "ScrollFillerSkeleton.module__compactUsername___NmluSn",
  "Mf": "ScrollFillerSkeleton.module__compactLine___NmluSn",
  "Zb": "ScrollFillerSkeleton.module__compactAttachment___NmluSn",
};

module.exports = exports;
